import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import EnquiryService from "../../services/enquiry.service";

// **Async Thunks**
export const getenquiryList = createAsyncThunk(
  "enquiry/getenquiryList",
  async (item, thunkApi) => {
    try {
      const response = await EnquiryService.getEnquiry(item);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const editenquiry = createAsyncThunk(
  "enquiry/editenquiry",
  async (item, thunkApi) => {
    try {
      const response = await EnquiryService.editEnquiry(item);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// **Initial State**
const initialState = {
  loading: false,
  error: "",
  enquiries: [],
};

// **Slice**
const enquirySlice = createSlice({
  name: "enquiry",
  initialState,
  extraReducers: (builder) => {
    builder
      // **Handle Get Enquiry List**
      .addCase(getenquiryList.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getenquiryList.fulfilled, (state, action) => {
        state.loading = false;
        state.enquiries = action.payload;
      })
      .addCase(getenquiryList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Edit Enquiry**
      .addCase(editenquiry.pending, (state) => {
        state.loading = true;
      })
      .addCase(editenquiry.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.enquiries.findIndex((e) => e.id === action.payload.id);
        if (index !== -1) {
          state.enquiries[index] = action.payload;
        }
      })
      .addCase(editenquiry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// **Export Reducer**
export default enquirySlice.reducer;
